import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isLoading: false,
    home_list_data: {
      upload: {}, // 接口参数
      scroll_top: 0, // 滚动条位置
      list: []
    },
    my_member_list_data: {
      upload: {}, // 接口参数
      scroll_top: 0, // 滚动条位置
      list: []
    },
    click_position:{
      upload: {}, // 接口参数
      scroll_top: 0, // 滚动条位置
      list: [],
      select: [],
      select_type:1,
      is_free_member:0
    },
    global_config: {},
    Legion_info:{
      tab_1:[],
      tab_2:[],
      index:0,
      tab_1_active_id: 0,
      tab_2_active_id: 0,
      best_list: [],
      list: [],
      status:false
    },
  },
  mutations: {
    update_Legion_info(state, payload){
      state.Legion_info = payload.Legion_info;
    },
    set_global_config(state, payload) {
      // loading
      state.global_config = payload.global_config;
    },
    updateLoadingStatus(state, payload) {
      // loading
      state.isLoading = payload.isLoading;
    },
    update_home_list_data(state, payload) {
      // loading
      state.home_list_data = payload.home_list_data;
    },
    update_my_member_list_data(state, payload) {
      // loading
      state.my_member_list_data = payload.my_member_list_data;
    },
    update_click_position(state, payload) {
      // loading
      state.click_position = payload.click_position;
    },
  },
  actions: {
    update_Legion_info({ commit }, Legion_info) {
      commit({
        type: "update_Legion_info",
        Legion_info: Legion_info
      });
    },
    set_global_config({ commit }, global_config) {
      commit({
        type: "set_global_config",
        global_config
      });
    },
    setLoadingStatus({ commit }, isLoading) {
      commit({
        type: "updateLoadingStatus",
        isLoading: isLoading
      });
    },
    set_home_list_data({ commit }, home_list_data) {
      commit({
        type: "update_home_list_data",
        home_list_data: home_list_data
      });
    },
    set_my_member_list_data({ commit }, my_member_list_data) {
      commit({
        type: "update_my_member_list_data",
        my_member_list_data: my_member_list_data
      });
    },
    set_click_position({ commit }, click_position) {
      commit({
        type: "update_click_position",
        click_position: click_position
      });
    }
  },
  modules: {
  }
})
